export default __webpack_public_path__ + "static/media/main_failed.5965b78f.png";